import { ChangeEvent} from 'react';
import Slider from '@material-ui/core/Slider';
import { t } from '@base/utils/helpers';
import styles from '../styles/createTableMatchPoints.module.scss';

export default function CreateTableMatchPoints(props: {
  value: number;
  handlerMatchPointsFee: (value: number) => void;
  disabled?: boolean;
}) {
  const { value, handlerMatchPointsFee, disabled } = props;

  function handleSliderChange(event: ChangeEvent<Record<string, unknown>>, newValue: number | number[]) {
    if (typeof newValue === 'number') {
      handlerMatchPointsFee(newValue);
    }
  }

  return (
    <section className={styles.match}>
      <div className={styles.title}>
        <div>{`${t('match')} ${t('points')}`}</div>
        <div>{value}</div>
      </div>
      <div className="slider-wrap">
        <Slider
          value={value}
          min={50}
          max={350}
          step={25}
          onChange={handleSliderChange}
          className={disabled ? 'disabled' : undefined}
        />
      </div>
    </section>
  );
};
